
export class AlertToasterOptions {
    timeOut = 5000;
    position = ['bottom', 'right'];
    animate = 'fromRight';
    preventDuplicates = true;
    maxStack  = 3;
    clickIconToClose = true;
    pauseOnHover = true;
    clickToClose	= true;
    lastOnBottom    = false;
}
